var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResourceProfiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #d6002e;\n        stroke-miterlimit: 10;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "19.9995 9.1671 15.4243 16.2335 13.0025 17.7112 13.3596 14.8967 20.7522 3.4787 22.8169 4.8156 21.0657 7.5203"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.7421,
    y: 6.3532,
    width: 5.0006,
    height: 5.0006
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.7421,
    y: 14.9011,
    width: 5.0006,
    height: 5.0006
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "10.3721 20.5213 10.3721 14.9011 13.3596 14.9011"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.2828,
    y: 6.3532,
    width: 5.0006,
    height: 5.0006
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceProfiles);
export default __webpack_public_path__ + "static/media/resource-profiles.ce9c8451.svg";
export { ForwardRef as ReactComponent };